import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import { updaterole } from "../graphQL/graphQuery";
import { deleteRoleDetail } from "../graphQL/graphMutation";

export const updateRoleService = async (values, id) => {
  let updateStatus = false;
  try {
    const res = await request(BASEURL, updaterole, {
      id:id,
      ...values,
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.message, "updateAppointmentService error");
    updateStatus = false;
  }

  return updateStatus;
};

export const deleteRoleService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, deleteRoleDetail, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "deleteAppointmentService error");
    delteStatus = false;
  }
  return delteStatus;
};
